import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';

interface PasswordStrengthMeterProps {
  strength: number;
  getColor: (strength: number) => string;
  getText: (strength: number) => string;
}

const PasswordStrengthMeter: React.FC<PasswordStrengthMeterProps> = ({ strength, getColor, getText }) => (
  <Box sx={{ width: '100%', mt: 1 }}>
    <LinearProgress
      variant="determinate"
      value={strength * 100}
      sx={{
        backgroundColor: '#e0e0e0',
        '& .MuiLinearProgress-bar': {
          backgroundColor: getColor(strength)
        }
      }}
    />
    <Typography variant="caption" color="textSecondary">
      Password Strength: {getText(strength)}
    </Typography>
  </Box>
);

export default PasswordStrengthMeter; 